// extracted by mini-css-extract-plugin
export default {"ModalFooter":"TimeModal_ModalFooter__sR3JN","PaginationButtons":"TimeModal_PaginationButtons__y6BuO"};